export default function selectTrelloListsById(state) {
  return state.integrations.thirdPartyData.trello.lists
}
